import { getProcedureRoute } from "@mx/gpl-common";
import format from "date-fns/format";
import Link from "next/link";
import { IProcedure } from "../../typings/filterEntities";
import FeaturedTag from "../FeaturedTag/FeaturedTag";
import Heading from "../Heading/Heading";
import { AvatarPlaceholderIcon } from "../Icons/Icons";
import styles from "./ProcedureCard.module.css";

interface IProps {
  procedure: IProcedure;
}

export default function ProcedureCard({ procedure }: IProps) {
  const { listingDate, isFeatured, maintainer, title, uid } = procedure;

  const formattedDate = format(new Date(listingDate), "P");

  return (
    <Link href={getProcedureRoute(uid, title)} className={styles.root}>
      <Heading component="h4" variant="h4">
        {title}
      </Heading>
      <div className={styles.meta}>
        <div>
          <div className={styles.maintainerName}>
            <div className={styles.maintainerImageWrapper}>
              {maintainer?.thumbnail.originalUrl ? (
                <img
                  className={styles.maintainerImage}
                  src={maintainer?.thumbnail.originalUrl}
                  width={16}
                  height={16}
                />
              ) : (
                <AvatarPlaceholderIcon width={16} height={16} />
              )}
            </div>
            {maintainer?.name}
          </div>
          <div className={styles.date}>{formattedDate}</div>
        </div>
        {!!isFeatured && <FeaturedTag />}
      </div>
    </Link>
  );
}
